import { FccOperatorRoleType } from '@backoffice-frontend/graphql'
import { keyframes } from '@emotion/react'
import { AirTrafficControlIcon, HeadsetIcon } from '@moia-dev/pace-icons'
import { type ComponentType, type SVGProps, useCallback } from 'react'

export const roleIcons: Record<
  FccOperatorRoleType,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  [FccOperatorRoleType.RiderSupport]: HeadsetIcon,
  [FccOperatorRoleType.RemoteAssistanceOperator]: AirTrafficControlIcon,
}

const pulseKeyframes = keyframes({
  '0%, 100%': { opacity: 1 },
  '50%': { opacity: 0.3 },
})

export const pulseStyles = (isPulsing: boolean) => ({
  animation: isPulsing ? `${pulseKeyframes} 1.5s ease-in-out infinite` : 'none',
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
})

export const useSyncedPulse = (isPulsing: boolean) =>
  useCallback(
    (element: HTMLElement | null) => {
      if (!isPulsing) return
      for (const animation of element?.getAnimations() ?? []) {
        animation.startTime = 0
      }
    },
    [isPulsing],
  )
